import { gql } from '@apollo/client'

export default gql(`
    query listAssetCategories($search: SearchInput $limit: Int $offset: Int $project: String){
        listAssetCategories( 
            search: $search
            limit: $limit
            offset: $offset
            project: $project
        ) {
        items {
            id
            slug
            name
            assetCount
            isTransferring
            isError
        }
        totalCount
    }
}`)
